<template>
  <div>
    <div v-if="events.length > 0">
      <ul class="list-group list-group-flush border-bottom border-light" v-for="event in events" :key="event.id">
        <div :class="[moment(moment().format('YYYY-MM-DD')).isSame(event.start_date) ? 'neo-primary-bg-light' : '', 'py-3']">
          <div class="d-flex">
            <div :class="[showActions ? 'col-md-6': 'col-md-8','col-9 neo-event-description-container']" @click="handleEventViewClick(event)">
              <div class="d-flex align-items-center">
                <div class="col-3 px-0 d-md-flex-inline text-left">
                  <div class="neo-event-date-cell">
                    <h4 class="mb-0">{{ moment(event.start_date).format('DD') }}</h4>
                    <small class="mb-0">{{ moment(event.start_date).format('MMM') }}, </small>
                    <small class="mb-0">{{ moment(event.start_date).format('YYYY') }}</small>
                    <p class="mb-0">
                      <small class="text-danger font-weight-bolder">
                        {{ getEventRange(event.start_date, event.end_date, event.end_time) }}
                      </small>
                    </p>
                  </div>
                </div>
                <div class="d-flex-inline">
                  <div class="neo-event-description-cell ml-3 ml-md-5">
                    <p class="mb-1 d-md-none" v-if="showEventType">
                      <a-tag :color="event.event_type === 'H' ? 'red' : 'blue'">
                        {{ getEventType(event.event_type) }}
                      </a-tag>
                    </p>
                    <p class="font-weight-bold mb-1">{{ event.title }}
                    </p>
                    <p class="mb-0">{{ event.description }}</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Start - End Dates -->
            <div :class="['d-none d-md-block col-md-2 text-center border-left border-light']">
              <p class="mb-1">
                <a-tag color="cyan">
                  {{ moment(event.start_date).format('DD-MM-YYYY') }} {{ event.start_time ? moment(event.start_time, 'HH:mm:ss').format('LT') : '' }}
                </a-tag>
              </p>
              <p class="mb-1">
                <a-tag color="pink" v-if="event.end_date || event.end_time">
                  {{ event.end_date ? moment(event.end_date).format('DD-MM-YYYY') : '' }} {{ event.end_time ? moment(event.end_time, 'HH:mm:ss').format('LT') : '' }}
                </a-tag>
              </p>
            </div>
            <!-- Event Types -->
            <div class="d-none d-md-block col-3 col-md-2 text-center border-left border-light" v-if="showEventType">
              <p class="mb-1">
                <a-tag :color="event.event_type === 'H' ? 'red' : 'blue'">
                  {{ getEventType(event.event_type) }}
                </a-tag>
              </p>
            </div>
            <!-- Actions -->
            <div class="col-3 col-md-2 text-right border-left border-light"  v-if="showActions">
              <span class="mr-md-2">
                <a href="javascript:;" class="text-dark neo-icon-btn" @click="handleEventViewClick(event)" v-if="rolesetting.viewable">
                  <i class="fe fe-eye"></i>
                </a>
              </span>
              <span>
                <a href="javascript:;" class="text-primary neo-icon-btn" @click="handleEventEditClick(event)" v-if="rolesetting.editable">
                  <i class="fe fe-edit"></i>
                </a>
              </span>
            </div>
          </div>
        </div>
      </ul>
    </div>
    <div v-else>
      <div class="text-center py-5" style="margin-top: 2rem;">
        <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K" alt="No Events">
        <div class="text-muted">No Events</div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { find } from 'lodash'

import { eventTypes, targetAudianceTypes } from '@/services/globaldata'

export default {
  name: 'EventsList',
  components: {
  },
  mounted: function() {

  },
  data: function() {
    return {
      loading: false,
      eventTypes,
      targetAudianceTypes,
      dateFormat: 'LL',
      timeFormat: 'hh:mm a',
    }
  },
  props: {
    events: {
      type: Array,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    showEventType: {
      type: Boolean,
      default: true,
    },
    rolesetting: { type: Object },
  },
  methods: {
    moment,
    getEventType(eventType) {
      return find(this.eventTypes, { value: eventType }).name
    },
    handleEventEditClick(event) {
      this.$eventBus.$emit('openCalendarEventEditModal', event)
    },
    handleEventViewClick(event) {
      this.$eventBus.$emit('openCalendarEventSingleViewModal', event)
    },
    getEventRange(startDate, endDate, endTime) {
      const startD = moment(startDate)
      let endD = moment(endDate)
      if (!endTime) {
        endD = moment(endDate + ' ' + '24:00:00')
      }
      const range = endD.diff(startD, 'days')

      if (range > 1) {
        return range + ' days'
      }
      return ''
    },
  },
}
</script>
